import { DateTime } from '@cheqroom/date-time';

import { Plan as PlanGroupkey } from '../features';
import type { ApiUserResponse, User } from './types';

/**
 * Maps the user API response (/users/call/me) to the auth User type.
 */
export function mapUserApiResponseToUser(api: ApiUserResponse): User {
	const picture = api.picture ?? '';
	return {
		...api,
		email: api.email,
		id: api._id ?? '',
		name: api.name,
		picture: { O: picture, XS: picture, S: picture, M: picture, L: picture },
		roleId: api.role ?? '',
		timezone: api.timezone ?? '',
		username: api.login ?? '',
		sync: api.sync ?? null,
		ssoOnly: api.ssoOnly ?? false,
		syncName: api.syncName ?? null,
		organisationId: api.group?.organisationId ?? '',
		workspace: {
			...api.group,
			id: api.group?._id ?? '',
			name: api.group?.name ?? '',
			timezone: api.group?.timezone,
			businessHours: api.group?.businessHours,
			tags: api.group?.tags ?? api.group?.raw?.tags ?? [],
			isInBetaProgram: api.group?.isInBetaProgram ?? api.group?.raw?.isInBetaProgram ?? false,
			signedUpAt: (() => {
				const signedup = api.group?.signedup ?? api.group?.raw?.signedup;
				if (signedup == null) return null;
				return DateTime.fromDate(new Date(signedup));
			})(),
		},
		subscription: {
			...api.group?.subscription,
			planId: api.group?.subscription?.subscriptionPlan?._id ?? '',
			kind: api.group?.subscription?.kind ?? '',
			status: api.group?.subscription?.status ?? '',
			plan: {
				...api.group?.subscription?.subscriptionPlan,
				family: api.group?.subscription?.subscriptionPlan?.family ?? '',
				groupKey: (api.group?.subscription?.subscriptionPlan?.groupKey as PlanGroupkey) ?? ('' as PlanGroupkey),
			},
		},
		preferences: {
			...api.group?.profile,
			firstDayOfWeek: api.group?.profile?.weekStart === 1 ? 'monday' : 'sunday',
		},
		contactId: api.customer?._id ?? '',
		customerId: api.customer?._id ?? '',
		publicKey: api.publicKey ?? '',
		customer: {
			...api.customer,
			_id: api.customer?._id ?? '',
			contactGroups: api.customer?.contactGroups ?? [],
		},
		profile: {
			viewSupportChat: api.profile?.viewSupportChat ?? false,
		},
	};
}
